export default "__VITE_ASSET__0a093f8a__"